import axios from 'axios'

export default {
  async search(orderDate, query, quoteId) {
    try {
      const response = await axios.get(`${quoteId}/FleetContracts`, {
        params: { orderDate, query },
      })
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },
  async setContract(orderDate, contractNumber, quoteId) {
    try {
      const response = await axios.post(`${quoteId}/FleetContracts`, {
        orderDate,
        contractNumber,
      })
      return response.data
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async removeContract(quoteId) {
    try {
      const response = await axios.delete(`${quoteId}/FleetContracts`)
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },
}
